import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download single csv
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadSingleCsvReducer(state = initialState.crashboxxFiles.singleCsv, action){

    switch(action.type)
    {
        case types.DOWNLOAD_SINGLECSV_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_SINGLECSV_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_SINGLECSV_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadSingleCsvReducer.js